import { useState } from "react";
import { Button, Form, notification, message, Input } from "antd";
import { BiLogoFacebookCircle } from "react-icons/bi";
import { FcGoogle } from "react-icons/fc";
// import { Auth, GoogleProvide, facebookProvider } from "../../config/firebase";
// import { signInWithPopup } from "firebase/auth";
import "../style.scss";
import Logo from "../../app/assets/images/logo.png";
import { API } from "../../../Config/API";
import { POST } from "../../../utils/apiCalls";
import { useNavigate } from "react-router-dom";
import { login } from "../../../redux/slices/userSlice";
import { useAppDispatch } from "../../../redux/hooks";
import { setSubscriptions } from "../../../redux/slices/subscription";

const LoginScreen = (props: any) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  //   const googleLogin = () => {
  //     try {
  //       signInWithPopup(Auth, GoogleProvide).then(async (data: any) => {
  //         const dat = await checkUserExist(data.user);
  //         const user = generatedUserData(dat, "google");
  //         localStorage.setItem("user", JSON.stringify(user));
  //         notification.success({
  //           message: "Success",
  //           description: "Login Successfull",
  //         });
  //         props.onCancel();
  //       });
  //     } catch (err) {
  //       message.error("Somehting went wrong");
  //     }
  //   };

  //   const checkUserExist = async (data: any) => {
  //     let URL = API.BASE_URL + API.LOGIN_GOOGLE;
  //     let obj = {
  //       email: data.email,
  //       username: data.displayName,
  //     };
  //     const response: any = await axios.post(URL, obj);
  //     return response.data;
  //   };

  const onLogin = async (values: any) => {
    setLoading(true);
    let body = {
      email: values.email,
      password: values.password,
    };
    let url = API.USER_LOGIN;
    try {
      const response: any = await POST(url, body);
      if (response?.id) {
        dispatch(login(response));
        if (response?.subscriptions?.length) {
          dispatch(setSubscriptions(response?.subscriptions));
        }
        notification.success({
          message: "Success",
          description: "login successfully.",
        });
        setLoading(false);
        navigate("/");
      } else {
        setLoading(false);
        notification.error({
          message: "error",
          description: "Invalid Credentials",
        });
      }
    } catch (error) {
      setLoading(false);
      notification.error({
        message: "error",
        description: "Something went wrong......!",
      });
    }
  };

  //   const fbLogin = () => {
  //     try {
  //       signInWithPopup(Auth, facebookProvider).then((data) => {
  //         const user = generatedUserData(data.user, "fb");
  //         localStorage.setItem("user", JSON.stringify(user));
  //         notification.success({
  //           message: "Success",
  //           description: "login successfully.",
  //         });
  //         setLoading(false);
  //         props.onCancel();
  //       });
  //     } catch (err) {
  //       message.error("Somehting went wrong");
  //     }
  //   };

  const generatedUserData = (data: any, type: any) => {
    let obj = {};
    if (type === "api") {
      obj = {
        id: data.id,
        username: data.username,
        email: data.email,
        admin: data?.admin,
      };
    } else if (type === "google") {
      obj = {
        id: data.id,
        username: data.full_name,
        email: data.email,
        photoURL: data.photoURL,
      };
    } else if (type === "fb") {
      obj = {
        username: data.displayName,
        email: "",
        photoURL: data.photoURL,
      };
    }
    return obj;
  };

  return (
    <div className="LoginScreen_box">
      <div className="LoginScreen_txt1">Sign in</div>
      <div className="LoginScreen_txt2" onClick={() => props.setAuthType()}>
        Don't have an account?{" "}
        <span className="LoginScreen_txt4">Create an Account</span>
      </div>
      <br />
      {/* <br /> */}
      {/* <div className="LoginScreen_hr">
        <span className="LoginScreen_txt5">OR</span>
      </div>
      <br /> */}
      <Form onFinish={onLogin}>
        <div className="LoginScreen_txt3">Email</div>
        <Form.Item name="email">
          <Input
            size="large"
            style={{ borderRadius: 4, borderColor: "gray" }}
          />
        </Form.Item>
        <div className="LoginScreen_txt3">Password</div>
        <Form.Item name="password">
          <Input.Password
            size="large"
            style={{ borderRadius: 4, borderColor: "gray" }}
          />
        </Form.Item>
        <Form.Item>
          <Button
            size="large"
            block
            type="default"
            loading={loading}
            htmlType="submit"
            style={{
              backgroundColor: " #b72c6f",
              height: 50,
              color: "#fff",
              borderRadius: 4,
            }}
          >
            Sign in
          </Button>
        </Form.Item>
      </Form>
    </div>
    // <div className="LoginScreen_box">sajeer</div>
  );
};

export default LoginScreen;
